export default __webpack_public_path__ + "static/lampa_polimeryzacyjna_mini-b270c4f391f8da9f8bb2d41beb68af9c.jpg";